module.exports = __webpack_public_path__ + "handshake.f1bed9b3.png";